import { render, staticRenderFns } from "./game-summary-card.vue?vue&type=template&id=956a955e&scoped=true&"
import script from "./game-summary-card.vue?vue&type=script&lang=ts&"
export * from "./game-summary-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956a955e",
  null
  
)

export default component.exports